export const ENVIRONMENT_VARIABLES = window.ENVIRONMENT_VARIABLES;
export const getEnvironmentVariables = () => window.ENVIRONMENT_VARIABLES;
